import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler
} from "react-native";
import HMActionBar from "../../../../customviews/HMActionBar";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import {moderateScale} from "../../../../tools/Scaling";
import  Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import HMListItemTitle from "../../../../customviews/HMListItemTitle";
import i18n from "../../../../I18n/i18n";

let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;
import HMMap1 from "../../../../customviews/map/HMMap";
import HMIcon from "../../../../customviews/HMIcon";

const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7'
}

export default class DetailsDeadScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {

            modalHeight: 0,
            isFull: false,


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
        };
     //   this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props

    }

    hiddenModal() {
        this.setState({
                visibleModal: ''
            },
            () => {

            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true

        });
    }



    async onFlyToPress(long, lat) {
        //await this.map.moveTo([ 49.66736778005486,34.08777640387088], 1000);
        /*      this.map.setCamera({
                  //  centerCoordinate: [49.66736778005486, 34.08777640387088],
                  centerCoordinate: [long, lat],
                  zoom: 16,
                  duration: 2000,
              })*/
        if (Platform.OS === "web") {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())
            this.map.mapRef.current.flyTo([lat, long], 18)

        }
        else {
            const camera = await this.map.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.animateCamera(camera, {duration: 2000});
            // this.onFlyToComplete();
        }
    }

    centerMap(long, lat) {

        this.map.setCamera({
            //centerCoordinate: [Constants.Longitude, Constants.Latitude],
            centerCoordinate: [long, lat],
            zoom: 16,
            // duration: 2000,
            // mode: MapboxGL.CameraModes.Flight,
        });

    }

    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    async componentDidMount() {

        this.setState({
            // dataSourcearraycategory: this.state.arraycategory,
            // dataSourcearrayBedrooms: this.state.arrayBedrooms
        })


    }

    componentWillMount() {
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;
        //   let checkVideo = files && files.length > 0 ? files.find(k => k.type === 'video/mp4') : false;
        //  let checkImage = files && files.length > 0 ? files.find(k => k.type === 'image/jpeg') : false;
    }

    componentWillUnmount() {

    }

    render() {


        let {name, family, fader, typeghabr, nugheteh, nuradif, nughabr, tabaghe, mahaldafn, typem, birth, title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, image, subject, date, category,} = this.props.route.params.item;
        // let checkVideo = video ? video : (files && files.length > 0 && files.find(k => k.type === 'video/mp4') ? files.find(k => k.type === 'video/mp4').video : null);
        // let checkImage = image ? image : (files && files.length > 0 && files.find(k => k.type === 'image/jpeg') ? files.find(k => k.type === 'image/jpeg').image : null);

        let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
        let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)
        return (
            <View style={{flex: 1,}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar menu
                                     props={this.props} statusBarTransparent
                            //   text={i18n.t('Privatizations.title')}
                                     text={i18n.t('constant.Details')}
                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />

                        <ScrollView
                            // ref={scroll => this._onRef('_scroll', scroll)}
                            style={{
                                //  backgroundColor: "white"
                            }}>

                            <View style={{flex: 1,}}>
                                {
                                    latitude && latitude != null && latitude != '' ?
                                        <View
                                            onPress={() => {
                                            }
                                                /*  NavigationService.navigateParams("MapShowScreen", {
                                                   //   latitude: data.latitude, longitude: data.longitude
                                                  })*/
                                            } style={{width: "100%", height: moderateScale(200)}}>
                                            <HMMap1
                                                ref={ref => (this.map = ref)}
                                             //   mapType={MAP_TYPES.NONE}


                                                style={{
                                                    width: "100%",
                                                    //height:height-moderateScale(200),
                                                    height: "100%", marginBottom: this.state.marginBottom
                                                }}
                                                initialRegion={{
                                                    latitude: parseFloat(latitude),
                                                    longitude: parseFloat(longitude),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}

                                                coordinate={{
                                                    latitude: parseFloat(latitude),
                                                    longitude: parseFloat(longitude),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}
                                            >
                                                {/*<MapView.UrlTile urlTemplate="https://c.tile.openstreetmap.org/{z}/{x}/{y}.png" />*/}
                                                {/*<MapView.UrlTile urlTemplate="http://185.113.56.14:8082/geoserver/gwc/service/tms/1.0.0/ahvaz:ahvaz@EPSG:900913@png/{z}/{x}/{y}.png" />*/}
                                             {/*   <MapView.UrlTile urlTemplate="http://185.113.56.14:8082/geoserver/gwc/service/tms/1.0.0/opengeo:countries@EPSG:900913@png/{z}/{x}/{-y}.png" />
                                                <MapView.UrlTile urlTemplate="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                                                <MapView.Marker coordinate={{
                                                    latitude: parseFloat(latitude),
                                                    longitude: parseFloat(longitude),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}/>
*/}
                                            </HMMap1>

                                            {
                                                // address ?
                                                1 === 1 ?
                                                    <TouchableOpacity
                                                        onPress={() => this.onFlyToPress(parseFloat(longitude), parseFloat(latitude))}
                                                        style={{
                                                            flexDirection: "row",
                                                            padding: moderateScale(5),
                                                            //     justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            width: "100%",
                                                            backgroundColor: "rgba(0, 0, 0, 0.4)",
                                                            position: "absolute",
                                                            bottom: 0,
                                                            left: 0
                                                        }}>
                                                        {/*      <TextView textt={data.address} selfStyle={{
                                            marginHorizontal: moderateScale(10),
                                            color: "white",
                                            fontSize: moderateScale(14),
                                            textAlign: "right",
                                            flex: 1
                                        }}/>*/}
                                                        <HMIcon type={"Feather"}                                                 name={"map-pin"}
                                                              style={{
                                                                  marginEnd: moderateScale(10),
                                                                  fontSize: moderateScale(22),
                                                                  color: Colors.white
                                                              }}/>
                                                        <HMTextView

                                                            type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: Colors.light3,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            //text={'اراک خ هپکو خ امام حسین'}
                                                            text={mahaldafn}
                                                            //   text={"98/03/21"}
                                                        />

                                                    </TouchableOpacity>
                                                    :
                                                    null
                                            }

                                        </View>
                                        : null
                                }
                                <HMListItemTitle
                                    text={'نام و نام خانوادگی'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={name + " " + family}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                />

                                <HMListItemTitle
                                    text={'نام پدر'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={fader}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                />

                                <HMListItemTitle
                                    text={'تاریخ تولد'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={birth}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                />
                                <HMListItemTitle
                                    text={'تاریخ وفات'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={date}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                />


                                <HMListItemTitle
                                    text={'شماره قطعه'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={nugheteh}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        // this.onShare()
                                    }}
                                />

                                <HMListItemTitle
                                    text={'نوع قطعه'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={typeghabr}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />
                                <HMListItemTitle
                                    text={'شماره ردیف'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={nuradif}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />
                                <HMListItemTitle
                                    text={'شماره قبر'}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    title={nughabr}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />

                              {/*  <HMListItemTitle
                                    text={i18n.t('constant.Image')}
                                    title={checkImage ? i18n.t('constant.View') : null}
                                    file={"image"}
                                    path={checkImage ? checkImage : null}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-image"}
                                    styleRoot={{marginTop: moderateScale(4)}}

                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />*/}

                                <View
                                    style={{
                                        flex: 1,
                                    }}>
                                    <View style={{

                                        flexDirection: 'row',
                                        ///  backgroundColor:'#a8ee7c',
                                        marginHorizontal: moderateScale(5),
                                        marginTop: moderateScale(4),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                    }}>
                                        <HMTextView


                                            type={"bold"}
                                            noFont={!I18nManager.getConstants().isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.blackLight,
                                                textAlign: 'center',
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={'پاسخ مردمی'}
                                            //   text={"98/03/21"}
                                        />


                                    </View>
                                    <FlatList
                                        // ItemSeparatorComponent={
                                        //     <View style={{
                                        //         width: '100%',
                                        //         height: moderateScale(1),
                                        //         backgroundColor: '#4f4f4f'
                                        //     }}/>
                                        // }
                                        data={comment === null || !comment ? [] : comment}
                                        renderItem={({item, index}) =>
                                            <View style={{
                                                // width: "100%",
                                                flex: 1,
                                                marginHorizontal: moderateScale(10),
                                                //  marginVertical: moderateScale(2),
                                                // padding: moderateScale(6)
                                            }}>
                                             {/*   <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                    }}>*/}
                                                        <View
                                                            style={{
                                                                //paddingVertical: moderateScale(10),
                                                                width: '100%',

                                                                padding: moderateScale(6)
                                                            }}
                                                        >


                                                            <View style={{flexDirection: 'row', alignSelf: "center",}}>
                                                                <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(12),
                                                                        color: Colors.colorDarkText,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={item.datetime}
                                                                    // text={moment(item.datetime).locale('fa').format('YYYY/M/D HH:mm:ss')}
                                                                    /*           text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                                   .locale('fa')
                                                                                   .format('YYYY/M/D HH:mm:ss')}  */

                                                                    //  text={moment(item.datetime, 'YYYY-M-D HH:mm:ss').locale('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                                    /*      text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                              .locale('fa')
                                                                              .format('YYYY/M/D HH:mm:ss')}*/
                                                                    // text={moment('2013-8-25 16:00:00', 'YYYY-M-D HH:mm:ss').local('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                                    //
                                                                    //
                                                                    // text={new Date('2013-8-25 16:40:00').toLocaleTimeString('fa-Ir')}
                                                                />
                                                            </View>
                                                            <View style={{
                                                                width: '100%',
                                                                height: moderateScale(1),
                                                                backgroundColor: '#eee',
                                                                alignSelf: 'center'
                                                            }}/>
                                                            <View style={{
                                                                flexDirection: 'row',
                                                                flex: 1,
                                                                marginVertical: moderateScale(6),
                                                                marginHorizontal: moderateScale(3)
                                                            }}>
                                                                <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(12),
                                                                        color: Colors.colorDark,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={item.comment}
                                                                    //   text={"98/03/21"}
                                                                />
                                                            </View>
                                                            {/*   <View style={{
                                                            width: '100%',
                                                            height: moderateScale(1),
                                                            backgroundColor: '#4f4f4f'
                                                        }}/>*/}


                                                        </View>
                                               {/*     </CardItem>
                                                </Card>*/}
                                            </View>
                                        }
                                    />


                                </View>
                            </View>

                        </ScrollView>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});

